
// eslint-disable-next-line
import ComlinkWorker from 'comlink-loader!./jpegtran.worker'; // inline loader

export type JpegtranWorkerApi = {
  rotateLossless(bytes: Uint8Array, args: string[]): Promise<Uint8Array | null>,
};

/**
 * jpegtran 専用の Worker を生成する。
 *
 * comlink-loader の型宣言 (src/worker/custom.d.ts) は共通 Worker 用の
 * ワイルドカード宣言のため、ここで本 Worker の API 形状に読み替える。
 */
export const createJpegtranWorker = (): JpegtranWorkerApi => (
  new ComlinkWorker() as unknown as JpegtranWorkerApi
);
